export const titleChangeFunc = (title) => {
    if (title) {
        const dataChange = title.getAttribute('data-change');
        const text = title.textContent;

        title.setAttribute('data-change', text);
        title.textContent = dataChange;
    }
};